import React from 'react';
import { Box } from '@mui/system';
import DashboardCompoment from '../components/common/DashboardCompoment';
import { dataStore } from '../Store';
import STERISLogoPng from '../styles/img/STERIS-Logo.png';
import { useUniqueEffect } from '../hooks';
import { useBreadcrumbs } from '../contexts/Breadcrumbs';


const Dashboard = (props) => {
	const { auth = {} } = dataStore?.getState() || {};
	const { roles = [] } = auth;
	const [, setBreadcrumbs] = useBreadcrumbs();
	useUniqueEffect(() => {
		setBreadcrumbs({ docTitle: 'Dashboard' });
	}, []);
	if (roles.includes('HuluAdmin')) {
		return <Box sx={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
			<img src={STERISLogoPng} alt="Hulu Admin Dashboard" />
		</Box>
	} else {
		return <DashboardCompoment
			fromModality={false}
			equipmentTypeId={0}
			fromDashboard={true}
			{...props}
		/>
	}
};
export default Dashboard;